module.exports = __webpack_public_path__ + "static/media/bg.7dae2fa5.png";